import { Component, ComponentFactoryResolver, OnInit, ViewChild, ViewContainerRef, ViewEncapsulation } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { DatatableComponent, ColumnMode } from '@swimlane/ngx-datatable';
import { ApiService } from 'app/shared/services/api.service';
import { environment } from 'environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import swal from 'sweetalert2';
import { DynamicDetailComponent } from '../../dynamic-detail/dynamic-detail.component';
import { ActivatedRoute, Router } from '@angular/router';
@Component({
  selector: 'app-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.scss',
  "../../../../../../assets/sass/libs/datatables.scss",],
encapsulation: ViewEncapsulation.None,
})
export class ReportComponent implements OnInit {

  @ViewChild(DatatableComponent) table: DatatableComponent;
  page = {
    pageNumber:0,
    offset: 0,
    pageSize: 100,
    totalPages:0
  };
  // row data
  public rows = [];
  public filterRows=[];
  public ColumnMode = ColumnMode;
  public limitRef = 100;
  selectedValue=''
  isFilter:boolean=false
  public columns = [
    { name: "Name", prop: "displayname" },
    {name:"Tag Type",prop:"tagcategories_ids"},
    { name: "Notes", prop: "notes" },
    { name: "Admin Notes", prop: "admin_notes" },
    { name: "Actions", prop: "Actions" },
  ];

  // private
  private tempData = []; 

  imageUrl=environment.apiUrls.imageUrl;
  baseUrl = environment.apiUrls.baseUrl

  tag_id:any
  searchVal:any;
  @ViewChild('name') inputName
  user_role:any
  tag_cat_list =[]
  selected_tag_cat_id = null
  isTagCat : boolean =false
  activeTab:any
  row_referrals=[]
  row_name:any
  referral_status =[
    // {name:'Current',_id:'current'},
    // {name:'Archived',_id:'archived'},
    { _id: 'interested' ,name:'Interested' },
    {_id:'informed',name:'Informed'},
    { _id: 'irrelevant' ,name:'Irrelevant' },
    { _id: 'referred',name:'Referred' },
    {_id:'frequent',name:'Frequent'},
    { _id: 'not_interested', name: 'Not Interested' },
    { _id: 'not_informed', name: 'Not Informed' },
    
  ]

  guideline_data:any
  row_id:any
  notes_admin_notes=''
  modal_for:any
  isAddUpdate_notes : boolean = false
  isAddUpdate_admin_notes : boolean = false
  empList =[]
  selected_ref_report = null
  modalFor:any
  formData = new FormData()

  constructor( public apiService:ApiService,
               private modalService: NgbModal,
               public toastr: ToastrService,
               private spinner: NgxSpinnerService,
               private activatedRoute:ActivatedRoute,private route:Router) { 
              this.user_role=JSON.parse(localStorage.getItem('user'))
              let setting_data = JSON.parse(localStorage.getItem('setting-record'))
                let key_data = setting_data.filter((item) => item.key == 'Referral Report')
                this.guideline_data = key_data[0]?._id
                this.activeStatusTab('interested')
                }

  ngOnInit(): void {
    
    this.setAndGetUsersByStatus();
    this.getAllEmployee()
  }
  activeStatusTab(tab) {
    const activetab = tab;
    if (activetab !== '') {
      this.route.navigate(
        [],
        { relativeTo: this.activatedRoute, queryParams: { status: activetab } }
      );
    }
  }
  setAndGetUsersByStatus() {
    this.activatedRoute.queryParams
      .subscribe((params: any) => {
        this.activeTab = params?.status;
        switch (this.activeTab) {
          case 'interested':
            this.getAllReferral(this.activeTab,this.activeTab);
            break;
          case 'irrelevant':
            this.getAllReferral(this.activeTab,this.activeTab);
            break;
           case 'not_informed':
            this.getAllReferral(this.activeTab,this.activeTab);
            break;
          case 'informed':
            this.getAllReferral(this.activeTab,this.activeTab);
            break;
          case 'not_interested':
            this.getAllReferral(this.activeTab,this.activeTab);
            break;
          case 'referred':
            this.getAllReferral(this.activeTab,this.activeTab);
            break;
           case 'frequent':
            this.getAllReferral(this.activeTab,this.activeTab);
            break;
          case 'irrelevant':
            this.getAllReferral(this.activeTab,this.activeTab);
            break;
        }
      })
  }
  getAllTagCategory(){
    this.apiService.getAllCategory(this.page.pageNumber + 1, this.limitRef).subscribe((res: any) => {
      this.spinner.hide();
      this.tag_cat_list = res?.data?.items
      let data = { displayname:'All',_id:'all'}
      this.tag_cat_list.push(data)
    })
  }
  getTagCatId(event){
    this.selected_tag_cat_id 
   
    this.apiService.getTagByTagCatgoryId(this.selected_tag_cat_id).subscribe((res: any) => {
      this.isTagCat =true
      this.rows = res.data
      this.page.totalPages=res.data.length
      
    })

  }
  
  getAllReferral(status,refStatus){
    this.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
    this.apiService.getAllReferralsByStatus(status,refStatus).subscribe((res:any)=>{
      this.spinner.hide();
      this.rows = res?.data?.users
      this.page.totalPages = res?.data?.totalCount
    })
  }
  pageChangeData(page:any){
    this.apiService.getTagsList(page.offset +1,page.pageSize).subscribe((res:any)=>{
      this.rows=res.data.items
      this.page.totalPages=res.data.totalCount
  
    })
  }
  getTagsFilter(data:any){
    let search=data
    if(search){
      this.apiService.getTagSearch(search).subscribe((res:any)=>{
        this.rows=res.data
      })
    }
    else{
      this.setAndGetUsersByStatus()
    }
  }
  resetFilter(){
    this.inputName.nativeElement.value=''
    this.searchVal = ''
    this.setAndGetUsersByStatus()
  }
  editTag(id:any){
  }
  deleteTag(){
    if(this.tag_id){
      this.apiService.tagDelete(this.tag_id).subscribe((res:any)=>{
        if(res.statusCode === 200){
          this.setAndGetUsersByStatus()
        }
        else{
          this.toastr.error(res.error)
        } 
        })
    }
    else{
      this.toastr.error('something went wrong !!')
    }
  }
   // ================== Delete Alert ========================
   ConfirmColor(id:any) {
    this.tag_id=id
    swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#2F8BE6',
      cancelButtonColor: '#F55252',
      confirmButtonText: 'Yes, delete it!',
      customClass: {
        confirmButton: 'btn btn-warning',
        cancelButton: 'btn btn-danger ml-1'
      },
      buttonsStyling: false,
    }).then( (result)=> {
      if (result.value) {  
        this.deleteTag()      
        swal.fire({
          icon: "success",
          title: 'Deleted!',
          text: 'Your imaginary file has been deleted.',
          customClass: {
            confirmButton: 'btn btn-success'
          },
        })
      } else if (result.dismiss === swal.DismissReason.cancel) {
        swal.fire({
          title: 'Cancelled',
          text: 'Your imaginary file is safe :)',
          icon: 'error',
          customClass: {
            confirmButton: 'btn btn-success'
          },
        })
      }
    });
  }
  openModalReferral(content,data,name){
    this.row_referrals = data
    this.row_name = name
    const modalOptions: NgbModalOptions = {
      size: 'lg', // 'sm', 'lg', or 'xl'
      backdrop: 'static',
    };
    const modalRef = this.modalService.open(content,modalOptions);
    modalRef.result.then((result) => {
      // console.log(`Modal closed with result: ${result}`);
    }, (reason) => {
      // console.log(`Modal dismissed with reason: ${reason}`);
    });
  }
  updateReferralStatus(id,status){
    let formData = new FormData()
    formData.append('status',status)
    this.apiService.updateUser(id ,formData).subscribe((res:any)=>{
      if(res?.statusCode === 200){
        this.toastr.success(res?.message)
        this.modalService.dismissAll()
        this.setAndGetUsersByStatus()
      }
      else this.toastr.error(res?.error)
    })
  }
  copyReferralLink(id){
    
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = `${this.baseUrl}/connect-to-learn?ref=${id}`
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.toastr.info('Referral link copied')

  }
  filter(data){
    this.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
    this.apiService.filterReferal(data).subscribe((res:any)=>{
      this.spinner.hide()
      this.rows = res?.data?.users
      this.page.totalPages = res?.data?.totalCount
    })
  }
  openDynamicModal(key_id:string) {
    const modalOptions: NgbModalOptions = {
      size: 'lg', // 'sm', 'lg', or 'xl'
      backdrop: 'static',
    };
    const modalRef = this.modalService.open(DynamicDetailComponent,modalOptions);
    modalRef.componentInstance.key_id = key_id;
  }
  openModalNotesAdminNotes(content,notes_adminNotes,id,prop,rowName){
    if(prop === 'Notes'){
      this.modal_for = prop
      this.row_name = rowName
      this.row_id = id
      this.notes_admin_notes = notes_adminNotes
    }
    if(prop == 'Admin Notes'){
      this.modal_for = prop
      this.row_name = rowName
      this.row_id = id
      this.notes_admin_notes = notes_adminNotes
    }
    const modalOptions: NgbModalOptions = {
      size: 'lg' 
    };
    const modalRef = this.modalService.open(content,modalOptions);
    modalRef.result.then((result) => {
      this.modal_for = prop
      this.row_name = rowName
      this.row_id = id
      this.notes_admin_notes = notes_adminNotes
      this.isAddUpdate_notes = false
      this.isAddUpdate_admin_notes = false

    }, (reason) => {
      
      this.modal_for = prop
      this.row_name = rowName
      this.row_id = id
      this.notes_admin_notes = notes_adminNotes
      this.isAddUpdate_notes = false
      this.isAddUpdate_admin_notes = false
    });
  }
  updateNoteAdminNote(){

    let formData = new FormData()
    if(this.modal_for === 'Notes'){
      formData.append('notes',this.notes_admin_notes)
    }
    if(this.modal_for === 'Admin Notes'){
      formData.append('admin_notes',this.notes_admin_notes)
    }

    
    this.apiService.updateUser(this.row_id ,formData).subscribe((res:any)=>{
      if(res?.statusCode === 200){
        this.toastr.success(res?.message)
        this.modalService.dismissAll()
        this.setAndGetUsersByStatus()
      }
      else this.toastr.error(res?.error)
    })
  }
  openModalForRefOrReport(content,id,ref_report_id,rowName,prop) {
    if(prop ==='Referral By'){

      this.modalFor = prop
      this.row_id = id
      this.selected_ref_report = ref_report_id
      this.row_name = rowName
    }
    if(prop ==='Report To'){
      this.modalFor = prop
      this.row_id = id
      this.selected_ref_report = ref_report_id
      this.row_name = rowName
    }
   
    const modalOptions: NgbModalOptions = {
      size: 'lg', // 'sm', 'lg', or 'xl'
      backdrop: 'static',
    };
    const modalRef = this.modalService.open(content,modalOptions);
    modalRef.result.then((result) => {
      this.modalFor = null
      this.row_id = null
      this.selected_ref_report = null
    },(reason)=>{
      this.modalFor = null
      this.row_id = null
      this.selected_ref_report = null
    })
  }
  getAllEmployee() {
    this.apiService.getEmployeeList(1, 100).subscribe((res: any) => {
      if (res.statusCode === 200) {
        this.empList = res.items
      }
    })
  }
  getEmpId(event){
    this.selected_ref_report
    if(this.modalFor ==='Referral By'){
      this.formData.append('refrence_by',this.selected_ref_report)
    }
    if(this.modalFor ==='Report To'){
      this.formData.append('report_to',this.selected_ref_report)
    }
  }
  updateRefAndReport(){
    this.apiService.updateUser(this.row_id ,this.formData).subscribe((res:any)=>{
      if(res?.statusCode === 200){
        this.toastr.success(res?.message)
        this.modalService.dismissAll()
        this.setAndGetUsersByStatus()
      }
      else this.toastr.error(res?.error)
    })
  }
}